export const isLightPageV2 = (pathname: string) => {
  return pathname === '/' || pathname === '/start';
};
